import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const CabsBreadcrumbs = ({ items }) => {
  const location = useLocation();
  const search = location.search || '';

  return (
    <nav className="text-xs text-slate-500" aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          const href = item.to ? `${item.to}${search}` : '';
          return (
            <li key={item.label} className="flex items-center gap-2">
              {!isLast && item.to ? (
                <Link className="hover:text-slate-700" to={href}>
                  {item.label}
                </Link>
              ) : (
                <span className="text-slate-700">{item.label}</span>
              )}
              {!isLast && <span className="text-slate-300">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default CabsBreadcrumbs;
